import type {
	FailedBid,
	SuccessfulBid,
} from 'Components/pages/VehiclesList/FiltersHeader/BulkBidding/BulkBiddingModal/useBulkBidding.types';
import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import ROUTES from 'Utilities/routes';

const { BULK_BIDDING } = ANALYTICS_CATEGORIES;
const { CTA_CLICKED } = SNOWPLOW_EVENTS;

interface BulkBiddingConfirmButtonClickedParams {
	failedBids: FailedBid[];
	success: boolean;
	successfulBids: SuccessfulBid[];
}

interface BuildLabelParams {
	failedBids: FailedBid[];
	successfulBids: SuccessfulBid[];
}

const createLabel = ({ failedBids, successfulBids }: BuildLabelParams) => {
	const successfulBidIds = successfulBids.map(({ bid }) => bid.id);
	const failedBidsEnquiryAndReason = failedBids.map(({ reason, vehicle: { id } }) => ({ enquiry_id: id, reason }));

	return JSON.stringify({
		failed: failedBidsEnquiryAndReason,
		successful_bid_ids: successfulBidIds,
	});
};

export const triggerBulkBiddingConfirmButtonClicked = ({
	failedBids,
	success,
	successfulBids,
}: BulkBiddingConfirmButtonClickedParams): void => {
	const label = createLabel({ failedBids, successfulBids });

	const eventPayload = getSnowplowEventPayload({
		category: BULK_BIDDING,
		customData: { button_label: 'Place bids', label, success, url: ROUTES.VEHICLE_LIST.as() },
		name: 'dlr_bulk_bidding_confirm_button_clicked',
		schemaName: CTA_CLICKED.SCHEMA,
		version: CTA_CLICKED.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
